import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { sha256 } from 'js-sha256';

@Injectable({
  providedIn: 'root'
})
export class ValidarDocumentoService {
  private apiUrl = `${environment.apiUrl}/hash/validar`;

  constructor(private http: HttpClient) {}

  generarHash(archivo: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && event.target.result) {
          const buffer = new Uint8Array(event.target.result as ArrayBuffer);
          const hash = sha256(buffer);
          resolve(hash);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => reject('Error al leer el archivo');
      reader.readAsArrayBuffer(archivo);
    });
  }

  validarHash(hash: string): Observable<boolean> {
    return this.http.post<boolean>(this.apiUrl, { hash });
  }
}
